import { useSyncExternalStore } from 'react';
import { useIntl } from '@/react-intl';
import { Button } from '@/design-system/ds-0/components/Button';
import { LOAD_CHOICES } from './simulationLoadChoice';
import { getStudioPlanWindow, subscribeStudioPlanWindow } from './studioPlanWindow';

const SEPARATOR = ' · ';

/** E2E-FIX1 (GAP-10) : dans le tiroir du Copilote, le même choix que la fenêtre du plan quand « Charger la simulation » trouve
 * des tables déjà remplies ; chaque bouton appelle le même geste (commandes existantes, confirmées et journalisées). */
export default function StudioPlanChoiceCard() {
  const intl = useIntl();
  const { choice } = useSyncExternalStore(subscribeStudioPlanWindow, getStudioPlanWindow, getStudioPlanWindow);
  if (!choice) return null;
  const t = (id: string) => intl.formatMessage({ id });
  return <div role="group" aria-label={t('moduleStudio.copilot.loadChoice')} className="mr-8 space-y-2 rounded-lg border border-portal-border px-3 py-2 text-sm">
    <p>{t('moduleStudio.copilot.loadChoice')}</p>
    <ul>
      {choice.occupants.simulations.map(item => <li key={item.id}><bdi>{choice.names[item.id] ?? t('moduleStudio.command.load.unnamedSimulation')}</bdi>{SEPARATOR}{intl.formatMessage({ id: 'moduleStudio.command.load.rows' }, { rows: item.rows })}</li>)}
      {choice.occupants.otherRows ? <li>{intl.formatMessage({ id: 'moduleStudio.command.load.otherRows' }, { rows: choice.occupants.otherRows })}</li> : null}
    </ul>
    {LOAD_CHOICES.map(key => <Button key={key} variant={key === 'unload-others' ? 'primary' : 'secondary'} disabled={!choice.available[key]} onClick={() => choice.choose(key)}>{t('moduleStudio.command.load.choice.' + key)}</Button>)}
  </div>;
}
